import { useState } from "react";
import { removeDuplicate } from "../../utils/remove-duplicate/removeDuplicate";
import Pagination from "../pagination/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";

const Favourites = ({ favourite }) => {
  const fav = removeDuplicate(favourite, (i) => i.product.id);

  const [value, setValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(6);
  const lastItem = currentPage * itemPerPage;
  const firstItem = lastItem - itemPerPage;
  const currentItemsOnPage = fav.slice(firstItem, lastItem);

  return (
    <>
      {favourite.length > 0 ? (
        <>
          <section className="bg-white p-3 mt-5">
            <p className="pb-3 font-normal text-xl">Things we love</p>
            <div className="flex flex-wrap gap-3 ">
              {currentItemsOnPage.map((fav) => (
                <div key={fav.id} className="w-[47.2%] md:w-[31%] lg:w-[160.5px] xl:w-[12%]">
                  <img
                    src={fav.product.product_image.front_view}
                    alt="favourite"
                    className="w-full h-[120px] md:h-200 xl:h-[130px]"
                  />
                  <p className="block md:hidden">{fav.product.product_name.substring(0, 9)}...</p>
                  <p className="hidden md:block">{fav.product.product_name}</p>

                  {fav.product.product_prices.map(({ price }) => (
                    <div className="flex items-center" key={Math.random()}>
                      <FontAwesomeIcon icon={faNairaSign} className="text-sm" />
                      <p
                        
                        className="font-bold text-sm"
                      >{`${price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="pb-5">
              <Pagination
                itemPerPage={itemPerPage}
                totalItem={fav.length}
                value={value}
                setValue={setValue}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </section>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Favourites;
